var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 2H3.77778C2.79594 2 2 2.79594 2 3.77778V7.33333M7.33333 18H3.77778C2.79594 18 2 17.2041 2 16.2222V12.6667M12.6667 2H16.2222C17.2041 2 18 2.79594 18 3.77778V7.33333M18 12.6667V16.2222C18 17.2041 17.2041 18 16.2222 18H12.6667M5.83301 10.0002H14.1663",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavScan);
export default __webpack_public_path__ + "static/media/nav-scan.c57914e415d117bbd8f1d8deca751abd.svg";
export { ForwardRef as ReactComponent };